import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  {
    logo: {
      display: 'inline-block',
      backgroundImage:
        "url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' version='1.0' width='746.29132' height='301.14566' id='svg63282'%3E%3Cdefs id='defs63284' /%3E%3Cg transform='translate(-343.6039,-123.8941)' id='layer1'%3E%3Cpath d='M 451.08706,130.9804 L 402.03177,271.16995 L 490.91432,271.16995 L 490.91432,130.9804 L 451.08706,130.9804 z M 496.70445,130.9804 L 496.70445,271.16995 L 586.25046,271.16995 L 537.19517,130.9804 L 496.70445,130.9804 z M 400.02131,276.96008 L 350.68456,417.95382 L 422.11629,417.95382 L 442.40186,360.67574 L 490.91432,360.67574 L 490.91432,276.96008 L 400.02131,276.96008 z M 496.70445,276.96008 L 496.70445,360.67574 L 545.88037,360.67574 L 565.66332,417.95382 L 637.59767,417.95382 L 588.26092,276.96008 L 496.70445,276.96008 z M 657.38062,130.9804 L 657.38062,271.16995 L 740.95555,271.16995 L 740.95555,130.9804 L 657.38062,130.9804 z M 746.72558,130.9804 L 746.72558,271.16995 L 833.97968,271.16995 C 825.73962,262.96028 815.83676,256.41461 804.82791,252.07056 C 824.56731,241.00962 837.87998,219.88644 837.87998,195.63687 C 837.87998,159.92748 809.00157,130.9804 773.28379,130.9804 C 773.00818,130.9804 772.73432,130.97696 772.4595,130.9804 L 746.72558,130.9804 z M 657.38062,276.96008 L 657.38062,417.95382 L 740.95555,417.95382 L 740.95555,276.96008 L 657.38062,276.96008 z M 746.72558,276.96008 L 746.72558,417.95382 L 772.4595,417.95382 C 772.73542,417.95643 773.00728,417.95382 773.28379,417.95382 C 820.76834,417.95382 859.25117,379.49452 859.25117,332.02665 C 859.25117,311.06616 851.72149,291.87276 839.24703,276.96008 L 746.72558,276.96008 z M 881.02451,130.9804 L 881.02451,271.16995 L 964.09682,271.16995 L 964.09682,130.9804 L 881.02451,130.9804 z M 969.88695,130.9804 L 969.88695,271.16995 L 1057.5432,271.16995 C 1049.3064,262.96052 1039.42,256.41454 1028.4115,252.07056 C 1048.1756,241.00962 1061.5439,219.88644 1061.5439,195.63687 C 1061.5439,159.92748 1032.5851,130.9804 996.86736,130.9804 C 996.61182,130.9804 996.35809,130.97744 996.10338,130.9804 L 969.88695,130.9804 z M 881.02451,276.96008 L 881.02451,417.95382 L 964.09682,417.95382 L 964.09682,276.96008 L 881.02451,276.96008 z M 969.88695,276.96008 L 969.88695,417.95382 L 996.10338,417.95382 C 996.3568,417.95602 996.61337,417.95382 996.86736,417.95382 C 1044.352,417.95382 1082.8146,379.49452 1082.8146,332.02665 C 1082.8146,311.06621 1075.2994,291.87277 1062.8306,276.96008 L 969.88695,276.96008 z ' style='fill:%23ff000f;fill-rule:nonzero;stroke:none' id='path63519' /%3E%3C/g%3E%3C/svg%3E%0A\")",
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
  },
  { name: 'AbbLogo' }
);

export interface AbbLogoProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'small' | 'regular' | 'big';
}

export const AbbLogo = (props: AbbLogoProps) => {
  const { variant = 'regular', style, ...other } = props;
  const classes = useStyles();
  let width = 0;
  let height = 0;

  switch (variant) {
    case 'small':
      width = 66;
      height = 25;
      break;
    case 'regular':
      width = 76;
      height = 29;
      break;
    default:
      width = 86;
      height = 33;
      break;
  }
  const styles = {
    width,
    height,
    ...style,
  };

  return <div className={classes.logo} {...other} style={styles} />;
};
